// 导入组件，组件必须声明 name
import yTableOld from "./src/index.vue";
// 为组件提供 install 安装方法，供按需引入
yTableOld.install = function(Vue) {
  Vue.component(yTableOld.name, yTableOld);
};
// 默认导出组件
export default yTableOld;
